import { Timestamp } from '@bufbuild/protobuf/wkt'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

export const timestampView = (ts: Timestamp | undefined): string => {
  const seconds = ts?.seconds ? Number(ts.seconds) : 0
  if (!seconds) return ''
  const date = new Date(seconds * 1000)
  return date.toISOString().slice(0, 19).replace('T', ' ')
}

export const timestampViewDate = (ts: Timestamp | undefined): string => {
  return timestampView(ts).slice(0, 10)
}

export const dateToTimestamp = (d: Date): Timestamp => {
  return { seconds: BigInt(Math.floor(d.getTime() / 1000)) } as Timestamp
}

export const timestampDatePicker = (ts: Timestamp | undefined): dayjs.Dayjs => {
  const seconds = ts?.seconds ? Number(ts.seconds) : 0
  dayjs.extend(utc)
  return dayjs.unix(seconds).utc()
}

export const datePickerToTimestamp = (d: dayjs.Dayjs): Timestamp => {
  return { seconds: BigInt(d.unix()) } as Timestamp
}

export const timestampRoundDays = (t: Timestamp | undefined): Timestamp => {
  if (!t) return {} as Timestamp
  return {
    seconds: BigInt(
      Math.floor(Number(t.seconds) / (24 * 60 * 60)) * (24 * 60 * 60)
    ),
  } as Timestamp
}

export const nowShiftDays = (d: number): Date => {
  const today = new Date()
  const tomorrow = new Date()
  tomorrow.setDate(today.getDate() + d)
  return tomorrow
}
